import styled from 'styled-components';

import { Button } from '../../../Button';
import { H1 } from '../../../Typography/Headings';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
`;

export const ReportModalButton = styled(Button)`
    width: 100%;
`;

export const ButtonsContainer = styled.div`
    padding: 0 1rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
`;

export const ReportModalHeading = styled(H1)`
    text-align: center;
`;

export const ReportModalSubHeading = styled.p`
    text-align: center;
    font-size: ${({ theme }) => theme.fontSizes[5]};
    color: #767676;
    font-weight: 400;
    letter-spacing: -0.0125rem;
`;

export const ReportModalError = styled.p`
    font-size: ${({ theme }) => theme.fontSizes[4]};
    color: ${({ theme }) => theme.colors.contacted};
    font-weight: 400;
    letter-spacing: -0.0125rem;
`;
